import { render, staticRenderFns } from "./DialogEditMainData.vue?vue&type=template&id=9c953236&scoped=true"
import script from "./DialogEditMainData.vue?vue&type=script&lang=js"
export * from "./DialogEditMainData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c953236",
  null
  
)

export default component.exports